

























import type { PropType } from '@nuxtjs/composition-api';
import {
  defineComponent,
  ref,
  useContext,
  useFetch
} from '@nuxtjs/composition-api';

import { useContentful } from '~/integrations/contentful/src/composables/useContentful';
import type { Product } from '~/modules/catalog/product/types';

export default defineComponent({
  name: 'ProductReinsurance',
  components: {
    VaimoBanner: () => import('atoms/VaimoBanner.vue')
  },
  props: {
    product: {
      type: Object as PropType<Product>,
      default: null
    }
  },
  setup(props) {
    const reinsuranceItems = ref([]);
    const { app } = useContext();
    const contentfulLocale = app.i18n.localeProperties.contentfulLocale;

    const getReinsurance = async () => {
      const ids = props.product?.reinsurance
        ?.map((item) => item.value)
        .filter(Boolean);

      if (!ids?.length) return;

      const { getEntries, entries } = useContentful('getReinsurance');

      await getEntries({
        'sys.id[in]': ids.join(','),
        limit: 10,
        include: 2,
        locale: contentfulLocale
      });

      entries.value?.items?.forEach(({ sys, fields }) => {
        const id = sys?.id;
        const heading = fields?.heading ?? '';
        const description = fields?.descr ?? '';
        const imgTitle = fields?.visual?.fields?.etitle ?? '';
        const visualSrc = fields?.visual?.fields?.vis?.fields?.file?.url ?? '';

        const isEmpty =
          !id || (!heading && !description && !visualSrc && !imgTitle);

        if (isEmpty) return;

        reinsuranceItems.value.push({
          id,
          heading,
          description,
          image: {
            src: visualSrc.length ? `https:${visualSrc}` : '',
            imgTitle
          }
        });
      });
    };

    useFetch(getReinsurance);

    return {
      reinsuranceItems
    };
  }
});
